// extracted by mini-css-extract-plugin
module.exports = {"faqQuestion":"faq-module--faqQuestion--2-L8O"};